export function getPagePromptHeaderId(containerId) {
    return containerId + '-header';
}
export const ReportPromptHeaderId = 'reportHeader';
